// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop_type_item-module__item--2eETs{display:inline-block;width:100%;padding:10px 12px 10px;font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;cursor:pointer;color:#36b;float:left;-webkit-border-radius:1px;-moz-border-radius:1px;border-radius:1px;border-left:4px solid transparent}.desktop_type_item-module__item--2eETs:hover{background-color:#f6f7f9bd}.desktop_type_item-module__selectedItem--3QxuN{border-color:#36b;font-weight:700;cursor:default}.desktop_type_item-module__selectedItem--3QxuN:hover{background-color:transparent}\n", ""]);
// Exports
exports.locals = {
	"item": "desktop_type_item-module__item--2eETs",
	"selectedItem": "desktop_type_item-module__selectedItem--3QxuN"
};
module.exports = exports;
